module.exports = __webpack_public_path__ + "static/scale-model-of-musical-stairs-in-berkeley-california-a6627e8be349e2aae7933d2a01123f51.png";